import { render, staticRenderFns } from "./MatchFilter.vue?vue&type=template&id=4e8c18b4&"
import script from "./MatchFilter.vue?vue&type=script&lang=js&"
export * from "./MatchFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.8.3_css-loader@3.6.0_lodash@4.17.21_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports